import api from '../../api/index.js'
export default {
  state: {
    numGame: sessionStorage.getItem('numGame') ? sessionStorage.getItem('numGame') : '1',
    cartListNum: JSON.parse(sessionStorage.getItem('cartList')) ? JSON.parse(sessionStorage.getItem('cartList')).length : '',
    gameName1: sessionStorage.getItem('gameName') ? sessionStorage.getItem('gameName') : '',
    uid: sessionStorage.getItem('uid') ? sessionStorage.getItem('uid') : '',
    userObj: {},
    currencyType: sessionStorage.getItem('currencyType') ? sessionStorage.getItem('currencyType') : '',
  },
  getters: {},
  mutations: {
    getCartListNum(state) {
      state.cartListNum = JSON.parse(sessionStorage.getItem('cartList')) ? JSON.parse(sessionStorage.getItem('cartList')).length : ''
    },
    getgameName(state) {
      state.gameName1 = sessionStorage.getItem('gameName')
      state.uid = sessionStorage.getItem('uid')
    },
    getnumGame(state) {
      state.numGame = sessionStorage.getItem('numGame')
    },
    userObjFun(state, data) {
      state.userObj = data
    },
    payTypeMutations(state, data) {
      state.currencyType = data
      sessionStorage.setItem('currencyType', data)
    },
  },
  actions: {
    async getUser({commit}) {
      try {
        let res = await api.login.getUserProfile()
        if (res) {
          commit('userObjFun', res.data)
        }
      } catch { }
    },
  },

}